import { render, staticRenderFns } from "./ProductFeedbackModal.vue?vue&type=template&id=b2af1e9e&scoped=true"
import script from "./ProductFeedbackModal.vue?vue&type=script&lang=js"
export * from "./ProductFeedbackModal.vue?vue&type=script&lang=js"
import style0 from "./ProductFeedbackModal.vue?vue&type=style&index=0&id=b2af1e9e&prod&lang=scss&scoped=true"
import style1 from "./ProductFeedbackModal.vue?vue&type=style&index=1&id=b2af1e9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2af1e9e",
  null
  
)

export default component.exports